import usePrefix from '@/hooks/usePrefix';
import React from 'react';
import { ControlLabel, FormGroup } from 'rsuite';
import { DatePicker } from '@/components/Bicester';
import dayjs from 'dayjs';
import { FormControl } from '@/components/formik-rsuite';
import { TypeAttributes } from 'rsuite/lib/@types/common';
import { BICESTER_FULL_DATE } from '@/constants/dateFormat';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';

const BicesterCardDatePicker = ({
  className,
  isEdit = true,
  notEditable = false,
  required = false,
  label,
  formKey,
  value,
  format = BICESTER_FULL_DATE,
  readOnlyFormat = BICESTER_FULL_DATE,
  disabledDate,
  calendarDefaultDate,
  placement,
  labelWeight,
  contentWeight,
  placeholder,
  ...props
}: {
  className?: string;
  isEdit?: boolean;
  notEditable?: boolean; // true为不可编辑
  required?: boolean; // 是否必填
  label?: string;
  formKey: string; // 与field.name一致，只读数据中也要传个key，否则accepter报错
  value?: string; // field.value为空时显示的value，一般用于只读数据
  format?: string;
  readOnlyFormat?: string; // 只读模式的format
  disabledDate?: (date?: Date) => boolean; // 禁用日期
  calendarDefaultDate?: Date; // 默认选中日期
  placement?: TypeAttributes.Placement;
  labelWeight?: number; // label的flex占比
  contentWeight?: number; // content的flex占比
  placeholder?: React.ReactNode;
  [key: string]: any;
}) => {
  const { prefix, classname } = usePrefix('bicester-card-item');

  return (
    <div className={`bicester-card-item-wrap ${className ?? ''}`}>
      <FormGroup className={`${classname} bicester-card-datepicker`}>
        {label && (
          <ControlLabel
            className={prefix('label')}
            style={{ ...(labelWeight && { flex: labelWeight }) }}
          >
            <div className={prefix('label-text')}>{label}</div>
            <div
              className={`${prefix('label-divider')} ${isEdit && required ? 'required' : ''}`}
            ></div>
          </ControlLabel>
        )}
        <div
          className={`${prefix('content-wrap')} ${isEdit ? prefix('content-wrap-isedit') : ''}`}
          style={{ ...(contentWeight && { flex: contentWeight }) }}
        >
          {isEdit && !notEditable ? (
            <FormControl
              className={prefix('content')}
              name={formKey}
              accepter={DatePicker}
              ranges={[]}
              format={format}
              disabledDate={disabledDate}
              calendarDefaultDate={calendarDefaultDate}
              placement={placement}
              placeholder={placeholder}
              {...props}
            />
          ) : (
            <FormControl
              name={formKey}
              accepter={({ field }) => (
                <div className={prefix('content-wrap-text')}>
                  {field.value || value
                    ? dayjs(field.value || value).format(readOnlyFormat)
                    : FORM_DEFAULT_DISPLAY}
                </div>
              )}
            />
          )}
        </div>
      </FormGroup>
    </div>
  );
};

export default BicesterCardDatePicker;
